import Vue from "vue";

export async function show(token) {
  const response = await Vue.prototype.$http.get(`/e/insurers/${token}`);

  return response.data;
}
